import { z } from "zod/v4";
import { moderationStatusSchema } from "./shared";

export const moderationItemSchema = z.object({
	id: z.string(),
	type: z.enum(["game", "club"]),
	title: z.string(),
	description: z.string().nullable().optional(),
	creator_id: z.string(),
	moderation_status: moderationStatusSchema,
	created_at: z.string(),
});
